<template>
  <div class="highlight-wrapper">
    <div
      v-for="(feat, idx) in max ? data.slice(0, max) : data"
      :key="feat.id"
      class="w-full"
      @mouseleave.self="handleLeave"
    >
      <HightLight
        :feat="feat"
        :idx="idx"
        :current="currentHover"
        :data-idx="idx"
        :loading="loading"
        :count="count"
        @mouseenter.self="handEnter"
        @enter="handEnter"
        @load="loadPayload"
        @click="handleSlideClick(feat)"
      />
    </div>
    <VideoModal v-model:open="open" :data="activeHighlight" />
  </div>
</template>

<script setup lang="ts">
import HightLight from '@/components/content/highlight/item.vue';
import VideoModal from '@/components/content/highlight/modal.vue';
import type { IProductHighlight } from '~/api/interface/publicize';

const props = defineProps({
  max: {
    type: Number,
    default: 0,
  },
  width: {
    type: Number,
    default: 285,
  },
  height: {
    type: Number,
    default: 160,
  },
  scaleHeight: {
    type: Number,
    default: 170,
  },
  count: {
    type: Number,
    default: 4,
  },
  data: {
    type: Array<IProductHighlight>,
    default: [],
  },
});

const currentHover = ref<number | undefined>();
const loading = ref(false);
const open = ref(false);
const activeHighlight = ref<IProductHighlight>();

const sliderWidth = computed(() => `${(1 * 100) / props.count}%`);

const sliderHeight = pxToRem(props.height, 1920);

const handEnter = (e: MouseEvent) => {
  const idx = (e.target as HTMLDivElement).dataset.idx;
  currentHover.value = idx ? +idx : undefined;
};

const handleLeave = () => {
  currentHover.value = undefined;
  loading.value = false;
};

const loadPayload = () => {
  loading.value = true;
};

const handleSlideClick = (feat: IProductHighlight) => {
  // trackEvent(TRACK_EVENT.CLICK_PRODUCT_HIGHLIGHTS_CARD, {
  //   title: feat.title,
  // })
  open.value = true;
  activeHighlight.value = feat;
};
</script>

<style lang="scss" scoped>
.highlight-wrapper {
  @apply grid grid-cols-4 gap-[15px] mt-[16px];
}
</style>
